<template>
  <div class="index">
    <navi :activeIndex="5"></navi>
    <div class="container">
      <img class="b1-img1" src="@/assets/logo_youren.png" alt="">
      <div class="c1">
        <div class="left">
          <img src="@/assets/lxwm_01.jpg" alt="">
          <div class="t1">厦门市湖里区高新技术园岭下南路77号201</div>
        </div>
        <div class="b7-right">
          <img class="b7-img2" src="@/assets/p_06-01.png" alt="商务总监二维码">
          <div class="b7-con">
            <div class="b7-text5">商务总监&nbsp&nbsp&nbsp&nbsp&nbsp吴先生</div>
            <div class="b7-text5">TEL:18060912324</div>
            <div class="b7-text5">微信：wzm448397012</div>
            <div class="b7-text5">EMAIL：michwu@foxmail.com</div>
          </div>
        </div>
      </div>
      <div class="t2">查看地图详情</div>
      <iframe id="ifr" class="ifr" src="http://www.myapro.com/map.html" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "AboutUs",
  components: {
    Navi
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  box-shadow: 0px 0px 6px #999;
  width: 1340px;
  /* height: 500px; */
  margin: 40px auto;
  padding: 20px;
}
.b1-img1 {
  display: block;
  width: 150px;
  margin: auto;
}
.c1 {
  margin-top: 30px;
  height: 180px;
  display: flex;
}
.left {
  display: inline-block;
  height: 100%;
  width: 50%;
  padding-top: 38px;
}
.t1 {
  font-size: 24px;
  color: #666;
  margin-top: 20px;
}
.b7-right {
  flex: 1;
  display: inline-block;
}
.b7-img2 {
  display: inline-block;
  float: left;
}
.b7-con {
  display: inline-block;
  float: left;
  margin-left: 50px;
}
.b7-text5 {
  font-size: 24px;
  color: #666666;
  margin-bottom: 13px;
  text-align: left;
}
.t2 {
  margin-top: 30px;
  font-size: 24px;
  color: #666666;
}
.ifr {
  margin-top: 30px;
  margin-bottom: 100px;
  width: 1200px;
  height: 770px;
}
@media only screen and (max-width: 800px) {
  .container {
    box-shadow: 0px 0px 0px #999;
    width: auto;
    margin: 60px 0px;
  }
  .c1 {
    margin-top: 30px;
    height: auto;
    display: block;
  }
  .left {
    display: block;
    height: auto;
    width: auto;
    padding-top: 38px;
  }
  .left img {
    width: 50px;
  }
  .t1 {
    font-size: 22px;
    color: #666;
    margin-top: 20px;
  }
  .b7-right {
    display: block;
    margin-top: 50px;
  }
  .b7-img2 {
    display: block;
    float: none;
    margin: auto;
  }
  .b7-con {
    display: block;
    float: none;
    margin: auto;
    margin-top: 20px;
  }
  .b7-text5 {
    text-align: center;
  }
  .t2 {
    margin-top: 60px;
  }
  .ifr {
    margin-top: 30px;
    margin-bottom: 100px;
    width: 100%;
    height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue